export function formatDate(dateString: string) {
  const date = new Date(dateString);

  const options = {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  return date
    .toLocaleString("en-GB", options as any)
    .replace(/\s(am|pm)$/i, (match) => match.toUpperCase());
}

export function getDayAbbreviation(dateString: string) {
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const date = new Date(dateString); // Convert the string to a Date object
  return days[date.getUTCDay()]; // Use getUTCDay() for UTC-based date
}

export function getMonthYear(date: string) {
  return new Date(date).toLocaleString("en-US", {
    month: "short",
    year: "numeric",
  });
}

export function getPreviousMonthYear(date: string) {
  const d = new Date(date);
  // Use the 1st of the month to avoid day-overflow (e.g. Jan 31 → Feb 31 → Mar 2)
  const prevMonth = new Date(d.getFullYear(), d.getMonth() - 1, 1);
  return prevMonth.toLocaleString("en-US", {
    month: "short",
    year: "numeric",
  });
}

export function getYearMonth(date: string) {
  return new Date(date).toLocaleString("en-US", {
    year: "numeric",
    month: "short",
  });
}

export function getTimeAMPM(date: string) {
  return new Date(date).toLocaleString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

export function getShortDate(dateString: string) {
  const date = new Date(dateString);
  const day = date.getUTCDate();
  const month = date.getUTCMonth() + 1;
  return `${day}/${month}`;
}
